export default "__VITE_ASSET__glNH0IU2__"